import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  numberField: {
    width: 78
  },
  marginValue: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 10,

    '& $numberField': {
      marginTop: [0, '!important']
    }
  },
  platform: {
    minWidth: 90,
    fontWeight: 'bold'
  }
})

export default useStyles
